var _jsxFileName = "/codebuild/output/src1806367562/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/FormContainer/index.tsx";
import React from 'react';
import { Stack } from '@adc/parallax-component-library';
// more informations: https://www.chromium.org/developers/design-documents/create-amazing-password-forms/
const FormContainer = ({
  children,
  hasBigGaps = false,
  hasHiddenUserInput = false
}) => {
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: e => e.preventDefault(),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    display: "flex",
    flexDirection: "column",
    gap: hasBigGaps ? '$6' : '$4',
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 7
    }
  }, children), hasHiddenUserInput ? /*#__PURE__*/React.createElement("input", {
    hidden: true,
    id: "userName",
    name: "username",
    autoComplete: "username",
    defaultValue: "",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 9
    }
  }) : null);
};
FormContainer.displayName = 'FormContainer';
export { FormContainer };